import React from 'react'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { selectorTypes } from '@easybutton/constants'

import { getOperationOptions } from '../../../../../utils/steps'
import { getSingularName, getTable } from '../../../../../utils/databases'
import { parseValue } from '../../../../../utils/values'

import Subnav from '../../../../Shared/Subnav'
import Button from '../../../../Shared/Button'
import Card from '../../../../Shared/Card'
import WrappedInput from '../../../../Shared/Forms/WrappedInput'
import Fields from './Fields'

export const FORM_NAME = 'configureStepForm'

const formSelector = formValueSelector(FORM_NAME)

const Form = function ConfigureStepForm({
  handleSubmit,
  submitting,
  database,
  action,
  stepId,
}) {
  const history = useHistory()

  const operationAndTable = useSelector(state =>
    formSelector(state, 'operationAndTable')
  )

  const selector = parseValue(
    useSelector(state => formSelector(state, 'selector'))
  )

  const { operation, table: tableName } = JSON.parse(operationAndTable || '{}')
  const table = getTable(database, tableName)

  const selectorColumn =
    table &&
    table.columns.filter(c => c.name === (selector && selector.column))[0]

  const selectorColumnName =
    selectorColumn && (selectorColumn.displayName || selectorColumn.name)

  const operationOptions = getOperationOptions(database)

  const inputs = action.details.inputs || []

  const selectorValues = [
    { label: 'Choose when running', value: 'newInput' },
    {
      label: 'Inputs',
      options:
        inputs.length > 0
          ? inputs.map(input => ({
              label: `Inputs > ${input.name}`,
              value: JSON.stringify({
                type: selectorTypes.INPUT,
                inputId: input.id,
              }),
            }))
          : [{ label: 'No inputs', disabled: true }],
    },
    {
      label: 'Find Record',
      options: table
        ? table.columns.map(col => ({
            label: `Find by ${col.displayName || col.name}`,
            value: JSON.stringify({
              type: selectorTypes.FIND_BY_COLUMN,
              column: col.name,
            }),
          }))
        : [{ label: 'No columns', disabled: true }],
    },
  ]

  const tableSingular = getSingularName(database, tableName)

  const emptyPlaceholder = operation === 'create' ? 'Empty' : 'No Change'

  return (
    <form onSubmit={handleSubmit}>
      <Subnav
        title="Configure Step"
        actions={
          <>
            <Button text onClick={history.goBack}>
              Back
            </Button>
            {action.details.steps.length > 1 || !action.draft ? (
              <Button>Save</Button>
            ) : (
              <Button>Next: Configure Action</Button>
            )}
          </>
        }
      />
      <Card>
        <Field
          name="operationAndTable"
          component={WrappedInput}
          options={operationOptions}
          label="Operation"
          placeholder="Select Operation..."
        />
        {['update', 'delete'].includes(operation) && (
          <>
            <Field
              component={WrappedInput}
              name="selector"
              options={selectorValues}
              label={`Which ${tableSingular}?`}
            />
            {selector && selector.type === selectorTypes.FIND_BY_COLUMN && (
              <Field
                component={WrappedInput}
                name="selectorComparison"
                label={selectorColumnName}
                placeholder={`Enter ${selectorColumnName}...`}
              />
            )}
          </>
        )}
      </Card>
      {operation && ['create', 'update'].includes(operation) && (
        <Card>
          <Fields
            database={database}
            tableName={tableName}
            emptyPlaceholder={emptyPlaceholder}
            stepId={stepId}
            actionId={action.id}
          />
        </Card>
      )}
    </form>
  )
}

export default reduxForm({ form: FORM_NAME })(Form)
